<template>
  <ion-page id="subscribe-page">
    <ion-content>

  <div v-show="showState == SHOW_EXPLAIN" class="repselector-left-text">
      <Explain :title="explainTitle" :message="explainMessage" />
  </div>

  <div v-show="showState == SHOW_SUBSCRIBE" >
    <TopLine :style="styleTopline" :title="subsciptionChoiceTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineSubscribeButtonClick"/>

    <div id="subscribe-buttons" :style="styleMiddle">
      {{ translatePhrase("After clicking one of the following buttons, or saying") }}' {{ translateEnglishWords("Command") }} {{ perpetualCommandWord }} {{ translateEnglishWords("Annual or Monthly") }} ', {{ translatePhrase("you'll be taken to the secure 'Stripe.com' website. (This might take a couple of seconds.)") }}
      <p>{{ translatePhrase("When you're done with that page, you should automatically be back in Verbal Chess.") }}</p>
       <ion-grid>
      <div v-show="canPerpetual == 'y'">
              <ion-row>
                <ion-col col-12>
        <ion-button expand="block" size="large" @click="doSubscribe('vp')" >
          <span class="ion-text-wrap">{{ translateEnglishWords("Perpetual") }} - ${{ perpetualPrice }}, {{ translateEnglishWords("Lifetime Subscription") }}</span></ion-button>
        </ion-col>
              </ion-row>
      </div>
                <ion-row>
                <ion-col col-6>
        <ion-button expand="block" size="large"  @click="doSubscribe('va')" >
          <span class="ion-text-wrap">{{ translateEnglishWords("Annual") }} - ${{ annualPrice }}/{{ translateEnglishWords("year Subscription") }}</span></ion-button>
         </ion-col>
                <ion-col col-6>
        <ion-button expand="block" size="large"  @click="doSubscribe('vm')" >
          <span class="ion-text-wrap">{{ translateEnglishWords("Monthly") }} - ${{ monthlyPrice }}/{{ translateEnglishWords("month  Subscription") }}</span></ion-button>
        </ion-col>
              </ion-row>
                          </ion-grid>

      </div>
    </div>
  

  <div v-show="showState == SHOW_BLURB" >
    <TopLine :style="styleTopline" :title="subscribingTitleString" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

    <div id="subscribe-blurb" :style="styleMiddle" class="container">
      <div v-html="currentText"></div>
    </div>
    <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
 </div>
 </ion-content>
 </ion-page>
 
</template>

<script setup>

  import { IonLabel,IonCol, IonRow, IonGrid, IonButton, IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import TopLine from '@/components/TopLine.vue'
  import Explain from '@/components/Explain.vue'
  import { parseWordsSaid } from '@/composables/wordlistSupport.js'

  import { ref, onMounted, watch } from 'vue'
  import { useConnectionStore } from '../stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import ToolBar from '@/components/ToolBar.vue'
  import { useGetData , generateErrorAlertText , getWebSiteURL } from '../composables/getData.js'
  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { translateEnglishWords, translatePhrase } from '@/composables/translation';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const subsciptionChoiceTitle = translateEnglishWords("Subscription Choices")
  const subscribingTitleString = translateEnglishWords("Subscribing") + "!"

  const canPerpetual = ref(connectionStore.getCanPerpetual)
  //console.log("CAN PERPETUAL ",canPerpetual.value)
  const perpetualCommandWord = (canPerpetual.value == "y") ? ref(translateEnglishWords("Perpetual") + ", ") : ref("")

  const isDark = ref(connectionStore.getDarkmode != "light")

  const wordlistBlurb = "command done verify subscribe scroll up down"
  const wordlistSubscribe = "command done perpetual annual monthly month scroll up down"
  const wordlistExplain = "command done"

  const wordlist = ref(wordlistBlurb)
  emit("word-list",wordlistBlurb)

  const keyTrigger = ref(0)
  const wordlistTrigger = ref(0)

  const loadingPageText = "<h3>" + translatePhrase("Loading Tour Explanation Pages") + "</h3>"
  const currentText = ref(loadingPageText)
  var showingNew = false

  var currentIndex = 0
  var currentCount = 0
  var currents = []

  var pages = []
  var pageCount = 0

  var news = []
  var newCount = 0

  const explainTitle = ref("")
  const explainMessage = ref("")

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const topLineString = ref("")
  const buttonSubscribeString = ref("")
  var isSubscriber = false
  var isDummyUser = false
  var isVerified = false
 
  var buttonAlreadyClicked = false

  const SHOW_BLURB = 0
  const SHOW_SUBSCRIBE = 1
  const SHOW_EXPLAIN = 2
  const SHOW_FREE_SUBSCRIPTION_STARTED = 2

  const showState = ref(SHOW_BLURB)

  const TOOLBAR_VERIFY = 0
  const TOOLBAR_SUBSCRIBE = 1

  const toolbarBlurbElements = [
    { index : TOOLBAR_VERIFY, label : translateEnglishWords("Verify Email") ,disabled : false},
    { index : TOOLBAR_SUBSCRIBE, label : translateEnglishWords("Subscribe") ,disabled : false},
  ]

  const TOOLBAR_SUBSCRIBE_PERPETUAL = 0
  const TOOLBAR_SUBSCRIBE_ANNUAL = 1
  const TOOLBAR_SUBSCRIBE_MONTHLY = 2
  const TOOLBAR_SUBSCRIBE_DONE = 3

  const toolbarSubscribePerpetualElements = [
    { index : TOOLBAR_SUBSCRIBE_PERPETUAL, label : translateEnglishWords("Perpetual") ,disabled : false},
    { index : TOOLBAR_SUBSCRIBE_ANNUAL, label : translateEnglishWords("Annual") ,disabled : false},
    { index : TOOLBAR_SUBSCRIBE_MONTHLY, label : translateEnglishWords("Monthly") ,disabled : false},
    { index : TOOLBAR_SUBSCRIBE_DONE, label : translateEnglishWords("Done") ,disabled : false}
  ]

   const toolbarSubscribeNoPerpetualElements = [
    { index : TOOLBAR_SUBSCRIBE_ANNUAL, label : translateEnglishWords("Annual") ,disabled : false},
    { index : TOOLBAR_SUBSCRIBE_MONTHLY, label : translateEnglishWords("Monthly") ,disabled : false},
    { index : TOOLBAR_SUBSCRIBE_DONE, label : translateEnglishWords("Done") ,disabled : false}
  ]

  var toolbarSubscribeElements = (canPerpetual.value == "y") ? toolbarSubscribePerpetualElements :
                    toolbarSubscribeNoPerpetualElements

  const TOOLBAR_EXPLAIN_DONE = 0

  const toolbarExplainElements = [
    { index : TOOLBAR_EXPLAIN_DONE, label : "Done" ,disabled : false}
  ]

  const toolbarElements = ref(toolbarBlurbElements)
  const toolbarTrigger = ref(0)

  var scrollTop = 0

  const priceMessage = ref("")

  const monthlyPrice = ref("MONTHLY")
  const annualPrice = ref("ANNUAL")
  const perpetualPrice = ref("PERPETUAL")
  var monthlyPriceInPennies = 0
  var annualPriceInPennies = 0
  var perpetualPriceInPennies = 0

  setButtonText()

  doStartupCheck(false,afterStartupCallbackRoutine)

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  onMounted(() => {
    getStripePricing()

  })

  function setButtonText() {
    isSubscriber = (connectionStore.getIsSubscriber == 1)
    isDummyUser = (connectionStore.getDummy != 0)
    isVerified = (connectionStore.getEmailVerified == "y")

    //console.log("set buttons",isSubscriber,isDummyUser,isVerified)
    if (isDummyUser) {
      topLineString.value = "Please login/register to sync across all devices and subscribe"
      toolbarBlurbElements[TOOLBAR_VERIFY].disabled = true
      toolbarBlurbElements[TOOLBAR_SUBSCRIBE].disabled = true
      toolbarBlurbElements[TOOLBAR_SUBSCRIBE].label = "Please Login/Register First"
    }
    else
    if (isVerified) {
      topLineString.value = ""
      toolbarBlurbElements[TOOLBAR_VERIFY].disabled = true
      toolbarBlurbElements[TOOLBAR_SUBSCRIBE].disabled = false
      toolbarBlurbElements[TOOLBAR_VERIFY].label = translateEnglishWords("Email Verified")
      toolbarBlurbElements[TOOLBAR_SUBSCRIBE].label = translateEnglishWords("Subscribe") + "!"
    }
    else {
      topLineString.value = translatePhrase("To Subscribe, please verify your email address")
      toolbarBlurbElements[TOOLBAR_VERIFY].disabled = false
      toolbarBlurbElements[TOOLBAR_SUBSCRIBE].disabled = true
      toolbarBlurbElements[TOOLBAR_SUBSCRIBE].label = "<- " + translatePhrase("Please Verify to Subscribe")
    }
    toolbarElements.value = toolbarBlurbElements
    toolbarTrigger.value++
  }
  
  function switchToBlurb() {
    showState.value = SHOW_BLURB
    wordlist.value = wordlistBlurb
    emit("word-list",wordlist.value)

    wordlistTrigger.value++
    toolbarElements.value = toolbarBlurbElements
    toolbarTrigger.value++
  }

  function switchToSubscribe() {
    showState.value = SHOW_SUBSCRIBE
    wordlist.value = wordlistSubscribe
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarElements.value = toolbarSubscribeElements
    toolbarTrigger.value++
  }

  function switchToExplain() {
    showState.value = SHOW_EXPLAIN
    wordlist.value = wordlistExplain
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarElements.value = toolbarExplainElements
    toolbarTrigger.value++
  }

  function processJsonResponse (json) {
    buttonAlreadyClicked = false
    //console.log(" in callback",json)
    if (json.hasOwnProperty('error')) {
      switchToExplain()
      showState.value = SHOW_EXPLAIN
      explainTitle.value = "*** ERROR ALERT ***"
      explainMessage.value = generateErrorAlertText(json)
      return;
    }

    const product = json['p']
    const code = json['c']
    const websiteURL = getWebSiteURL()
    const url = websiteURL + "stripe1_verbal_checkout.php?p=" + product + '&c=' + code 

    // stripe can't run inside an iframe.
    if (window.top !== window.self) {
      // The page is inside an iframe.
      console.log("This page is inside an iframe.");
      window.open(url, '_blank');
      window.open(url);
    } 
    else {
      // The page is not inside an iframe (it's the top-level window).
      console.log("This page is not inside an iframe.");
      location.href = url
    }

    //console.log(url)
    //window.open(url, '_blank');
    //window.open(url);
  }

  function doSubscribe(whatOrder) {
    if (buttonAlreadyClicked)
      return

    buttonAlreadyClicked = true
    //console.log("what ordered",whatOrder)

    var formData = { p : whatOrder  }
    useGetData("getweb_stripe_code.php", formData, processJsonResponse)

  }

    function toplineSubscribeButtonClick(whatClicked) {
    //console.log("toplineSubscribeButtonClick",whatClicked)
    switch (whatClicked) {
      case "done" :
        switchToBlurb()
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  // this is only on page with buttons
  function toolbarClick(arrayIndex) {
    switch (showState.value) {
      case SHOW_BLURB :
        switch (arrayIndex) {
          case TOOLBAR_VERIFY :
            processWords("command verify")
            break
          case TOOLBAR_SUBSCRIBE :
            processWords("command subscribe")
            break
        }
        break
      case SHOW_SUBSCRIBE :
        switch (arrayIndex) {
          case TOOLBAR_SUBSCRIBE_PERPETUAL :
            processWords("command perpetual")
            break
          case TOOLBAR_SUBSCRIBE_ANNUAL :
            processWords("command annual")
            break
          case TOOLBAR_SUBSCRIBE_MONTHLY :
            processWords("command monthly")
            break
          case TOOLBAR_SUBSCRIBE_DONE :
            processWords("command done")
            break
        }
    }
  }


  function afterStartupCallbackRoutine(stuffChanged) {
    setButtonText()
  }

  function processWords(text) {
    //console.log("text in engine Menu ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "scroll" :
        if (showState.value == SHOW_BLURB)
          scrollElement("subscribe-blurb",returnArray[1])
        else
          scrollElement("subscribe-buttons",returnArray[1])
        break
      case "done" :
        if (showState.value == SHOW_BLURB) {
          emit("where-next","/")
          //router.replace({ path: "/"})
        }
        else
          switchToBlurb()
        break
      case "verify" :
        if (toolbarBlurbElements[TOOLBAR_VERIFY].disabled == false)
          doSendVerifyEmail()
        break
      case "subscribe" :
        //console.log("subscribe",toolbarBlurbElements[TOOLBAR_SUBSCRIBE].disabled)
        if (toolbarBlurbElements[TOOLBAR_SUBSCRIBE].disabled == false) {
          //console.log("Switch to BUttons")
          switchToSubscribe()
        }
        break
      case "perpetual" :
        if (canPerpetual.value == "y")
          doSubscribe('vp')
        break
      case "annual" :
        doSubscribe('va')
        break
      case "monthly" :
        doSubscribe('vm')
        break
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "done") {
            return ["done",""]
        }
        if (currentWord == "scroll") {
          if (nextWord == "up") {
              return ["scroll", "up"]
          }
          if (nextWord == "down") {
              return ["scroll", "down"]
          }
        }
        // add choices here
        if (showState.value == SHOW_BLURB) {
          if (currentWord == "verify")
            return ["verify", ""]
          if (currentWord == "subscribe")
            return ["subscribe", ""]
        }
        if (showState.value == SHOW_SUBSCRIBE) {
            if (canPerpetual.value == "y" && currentWord == "perpetual")
              return ["perpetual",""]
            if (currentWord == "annual")
              return ["annual",""]
            if (currentWord == "monthly" || currentWord == "month")
              return ["monthly",""]
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

  function processVerifyJsonResponse (json) {
    //console.log(" in email verification callback",json)
    if (json.hasOwnProperty('error')) {
      showState.value = SHOW_EXPLAIN
      explainTitle.value = "*** ERROR ALERT ***"
      explainMessage.value = generateErrorAlertText(json)
      return;
    }
    topLineString.value = translatePhrase(json['mess'])
    toolbarBlurbElements[TOOLBAR_VERIFY].disabled = true
    toolbarTrigger.value++

  }

  function doSendVerifyEmail () {
    topLineString.value = translatePhrase("Sending Verification Email") +  "..."

    const subjectForEmail = "Verbal Chess - " + translatePhrase("Email Verification Request")
    const toEmail = "Verbal Chess" + translateEnglishWords("User")
    const greetingForEmail = translateEnglishWords("Hi")
    const topPartOfEmail = translatePhrase("To verify your email address with the Verbal Chess website, either click on the link below or copy it into your browser. It will bring up a webpage that will register your verification.")
    const endPartOfEmail = translatePhrase("If you have any questions, please email me at")

    var formData = { 
      subject : subjectForEmail,
      to_name : toEmail,
      greeting : greetingForEmail,
      top : topPartOfEmail,
      end : endPartOfEmail
    }
  
    useGetData("send2_verbal_verification_email.php", formData, processVerifyJsonResponse)
  }

  function processStripePricingJsonResponse(json) {
    //console.log("*** in get stripe pricing json callback",json)
    if (json.hasOwnProperty('error')) {
      switchToExplain()
      showState.value = SHOW_EXPLAIN
      explainTitle.value = "*** ERROR ALERT ***"
      explainMessage.value = generateErrorAlertText(json)
      return;
    }

    annualPriceInPennies = json['a']
    monthlyPriceInPennies = json['m']
    perpetualPriceInPennies = json['p']

    annualPrice.value = (parseFloat(annualPriceInPennies)/100).toFixed(2)
    monthlyPrice.value = (parseFloat(monthlyPriceInPennies)/100).toFixed(2)
    perpetualPrice.value = (parseFloat(perpetualPriceInPennies)/100).toFixed(2)

    priceMessage.value = json['mess']

    getSubscribeText()

  }

  function getStripePricing() {
    var formData = { product : "verbal"  }

    //console.log("in get stripe Pricing",formData)
    useGetData("getweb9_stripe_pricing.php", formData, processStripePricingJsonResponse)
  }

  // replaces the XYZb_l_a_hXYZ with word translations.
  
  function patchUpWords(page,languageUsed) {
    var pieces = page.split("~")

    //console.log("PIECE COUNT",pieces.length,languageUsed)
    if (pieces.length == 1)
      return (page)

    if (pieces.length % 2 == 0) {
      console.log("************************ Explain Page Has unbalanced XYZ ***********")
    }

    // handle perpetualPrice, annualPrice, monthPrice
    for (var i=1; i < pieces.length; i += 2) {
      const collapsed = pieces[i];
      switch (collapsed) {
        case "perpetualPrice" :
          pieces[i] = perpetualPrice.value
          break
        case "annualPrice" :
          pieces[i] = annualPrice.value
          break
        case "monthlyPrice" :
          pieces[i] = monthlyPrice.value
          break
      }
    }

    if (languageUsed != "en") {
      for (var i=1; i < pieces.length; i += 2) {
        const collapsed = pieces[i];
        //console.log("collapsed",collapsed)
        pieces[i] = translateEnglishWords(collapsed)
      }
    }

    //console.log("PIECES",pieces)
    return (pieces.join(""))
  }

function processTourJsonResponse (json) {
    //console.log(" tour callback",json)

    // fake the page using the error
    if (json.hasOwnProperty('error')) {
      json['programRun'] = "getxyz_verbal_tour.php"
      json['page_count'] = 1
      json['new_count'] = 0
      json['page0'] = "<h3>*** ERROR ALERT ***</h3><p>" + generateErrorAlertText(json)
    }

    const languageUsed = json['language']
    pageCount = json['page_count']
    newCount = json['new_count']

    //console.log("page count",pageCount,newCount)
    pages = []
    news = []

    if (pageCount == 0 && newCount == 0)
      return

    for (var i=0; i < pageCount; i++) {
      var pageText = json['page' + i]
      pageText = patchUpWords(pageText,languageUsed)
      pages.push(pageText)
    }
    for (var i=0; i < newCount; i++) {
      var newText = json['new' + i]
      newText = patchUpWords(newText,languageUsed)
      news.push(newText)
    }

    //console.log("show new",showingNew)
    //console.log("pages",pages)
    currentIndex = 0
    currentCount = (showingNew) ? newCount : pageCount
    currents = (showingNew) ? news : pages
    currentText.value = currents[0]
    //console.log("CURRENT",currentText.value)
    keyTrigger.value++
  }

  function getSubscribeText() {

    const connectionStore = useConnectionStore()
    const languageInUse = connectionStore.getLanguageInUse

    const verbalVersion = connectionStore.getVersion

    var formData = {
      os : "web",
      version : verbalVersion,
      screen : "subscribe",
      language : languageInUse
    }
    
    //console.log("*** get subscribe formdata",formData)
    useGetData("get5_verbal_tour.php", formData,processTourJsonResponse)
  }
</script>

<style scoped>

h2 {
  margin-top: 0px;
  color: steelblue;
  text-align: center;
}
h3, h4, h5 {
  margin-top: 10px;
  color: steelblue;
  text-align: left;
}

.subscriber-font {
    font-family : "Nunito, sans-serif";
}

ul {
  padding-left : 30px;
}

.indent-small-print {
  margin: 20px 40px;
  font-size: small;
  font-style: italic;
}

.topline-background-dark {
  margin-top:10px;
  margin-bottom: 10px;
  background-color: #403726;
  color : white;
  text-align: center;
}

.topline-background-light {
  background-color : #ebf2f2;
  margin-top:10px;
  margin-bottom:10px;
  color : black;
  text-align: center;
}

.container {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.container :deep(p) {
  margin-bottom : 10px;
}

.container :deep(h2) {
  margin-top: 0px;
  color: steelblue;
  text-align: center;
}

.container :deep(h3) {
  margin-top: 10px;
  color: steelblue;
  text-align: left;
}

.container :deep(ul) {
  padding-left : 30px;
}

.container :deep(li) {
  margin-left : 20px;
}

.container :deep(b) {
  font-weight: bold;
}
.container :deep(strong) {
  font-weight: bold;
  /* color:yellow; */
}

.container :deep(.indent-small-print) {
  margin: 20px 40px;
  font-size: small;
  font-style: italic;
}
</style>